/* eslint-disable */

import axios from 'axios';
import api from '../api';

const customers = [
  {
    'first_name': 'stephen',
    'last_name': 'knapper',
    'address': '123 st',
    'phone': '1234234234',
    'email': 'me@me.com',
    'id': 1,
  },
  {
    'first_name': 'bill',
    'last_name': 'knapper',
    'address': '324 st',
    'phone': '123534234',
    'email': 'me@this.com',
    'id': 2,
  },
  {
    'first_name': 'steve',
    'last_name': 'johnson',
    'address': '12 st',
    'phone': '1234236734',
    'email': 'this@me.com',
    'id': 3,
  },
];

const state = {
  loading: false,
  customers,
};

// getters
const getters = {

};

// actions
const actions = {
  initCustomers: context => {
    context.commit('SET_LOADING', true);
    api.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${localStorage.getItem('token')}`;
    api
      .get(
        'http://0.0.0.0:8000/shop/dashboard/customers/990f40c4-a1d9-47b4-86d2-745f5b695c5f/',
      )
      .then(response => {
        context.commit('SET_CUSTOMERS', response.data);
        context.commit('SET_LOADING', false);
      })
      .catch(error => {
        context.commit('SET_LOADING', false);

        console.log('ERROR');
        console.log(error);
      });
  },
};

// mutations
const mutations = {
  SET_CUSTOMERS(state, customers) {
    state.customers = customers;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
};
